export default __webpack_public_path__ + "static/media/mlodz1.a880dc90.jpg";